import React from 'react'
import BlankPage from '../../components/blank_page'
import IntlMessages from '../../util/IntlMessages'
import Comeback from '../../components/comeback'
import * as constants from '../../constants'

export default function IncentivePlan() {
    return (
        <React.Fragment>
            <Comeback title={<IntlMessages id="incentivePlan" />} />
            <BlankPage type={constants.BLANK_PAGE_INCENTIVE} />
        </React.Fragment>
    )
}
